import React, {
  createContext, useContext, useEffect,
} from 'react';

import * as Sentry from '@sentry/node';

import camelcaseKeys from 'camelcase-keys';
import { useImmerReducer } from 'use-immer';
import leadReducer, {
  LeadAction,
  REFRESH,
  INIT,
  BILLING_INFO,
  HOME_INFO,
  SET_PACKAGE,
  SET_DISCOUNT,
  SCHEDULE,
  SET_RESIDENCE,
  SET_TIP,
  SET_APPOINTMENT,
  CLEAR,
} from './leadReducer';
import { LeadState } from './lead.types';
import leadSession from './leadSession';
import emptyLeadState from './emptyLeadState.json';

const LeadContext = createContext(null);

export type LeadContextHook = {
  lead: LeadState;
  dispatchLead: Function;
}

interface LeadProviderProps {
  children: React.ReactNode;
}

const LeadProvider : React.FC<LeadProviderProps> = ({ children } : LeadProviderProps) => {
  const [
    lead,
    dispatchLead,
  ] = useImmerReducer<LeadState, LeadAction>(leadReducer, emptyLeadState);

  useEffect(() => {
    // console.log('Getting Lead Session via Provider');
    leadSession.get()
      .then((data) => {
        // console.log('Lead Provider Use Effect');
        // console.log(data);
        if (data?.data?.lead) {
          const leadData = camelcaseKeys(data.data.lead);
          // console.log(leadData);
          dispatchLead({ type: REFRESH, payload: leadData });
          // setLead(leadData);
        }
      })
      .catch((error) => {
        // console.log('Catch Block');
        // console.log(error);
        Sentry.captureException(error);
        return error;
      });
  }, []);

  return (
    <LeadContext.Provider value={{ lead, dispatchLead }}>
      {children}
    </LeadContext.Provider>
  );
};

const useLeadContext = () : LeadContextHook => useContext(LeadContext);

export {
  LeadContext as default,
  LeadProvider,
  useLeadContext,
  REFRESH,
  INIT,
  BILLING_INFO,
  HOME_INFO,
  SET_PACKAGE,
  SET_DISCOUNT,
  SCHEDULE,
  SET_RESIDENCE,
  SET_TIP,
  SET_APPOINTMENT,
  CLEAR,
};
